import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import TextField from "../../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import { AjustarFeriasService } from "../../../../services/AjustarFeriasService";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { SolicitarFeriasService } from "../../../../services/SolicitarFeriasService";
import { FeriasEscolaresService } from "../../../../services/FeriasEscolaresService";
import moment from "moment";

export default {
  name: "DefinirFeriasEscolares",
  components: {
    FormDialog,
    SelectField,
    TextField,
    PeriodoField,
    TextAreaField
  },
  props: {
    selected: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },
  data: () => ({
    data: [],
    justificativa: "",
    subtitulo: "Por favor selecione um exercício",
    saldoFerias: 0,
    diasRestantes: 0,
    justificativaDialog: false,
    exerciciosOptions: [],
    loading: {
      btn: false,
      field: false,
      btnApprove: false,
      btnRefuse: false,
    },
    form: {},
    campos: 0,
  }),
  beforeMount() {
    this.initializeForm();
    this.getExercicioItems();
    this.getFeriasEscolar();
    this.pegarDiasRestantesDaParecela();
  },
  watch: {
    isOpen: function () {
      this.initializeForm();
      this.getExercicioItems();
      this.getFeriasEscolar();
    },
    formForWatcher: {
      handler: function (newValue, oldValue) {
        newValue.forEach((value, index) => {
          if (value.dataInicio != oldValue[index].dataInicio && value.numeroDias != "") {
            this.calculateDays(index);
          }
        })
      },
      deep: true
    },
    "form": {
      handler(newValue) {
        if (newValue.length === 1) {
          this.$forceUpdate();
        }
      },
      deep: true,
    },
  },
  methods: {
    initializeForm() {
      this.campos = 1
      this.form = [{
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        justificativa: null,
        idFerias: null,
        idStatus: null,
      }]

    },
    async pegarDiasRestantesDaParecela(index, event) {
      if (event !== undefined) {
        this.form[index].exercicio = event;
        await this.atualizarSaldoFerias(index);
        if (this.form.length === 1) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      }
    },
    async getFeriasEscolar() {
      const response = await AjustarFeriasService.getById(this.selected[0].idFerias);

      if (Object.keys(response).length > 0) {
        this.form[0].justificativa = response.justificativa
        this.form[0].exercicio = parseInt(this.selected[0].exercicio)
        this.form[0].dataInicio = this.selected[0].dataIni
        this.form[0].dataFim = this.selected[0].dataFin
        this.form[0].numeroDias = this.selected[0].diasFerias
        this.form[0].idFerias = this.selected[0].idFerias
        this.form[0].idStatus = this.selected[0].idStatus
      }
    },
    prepareForm() {
      const formData = new FormData();
      let form = true;
      this.form.forEach((element, index) => {

        if (element.dataInicio == null || element.dataFim == null || element.exercicio == "" || element.numeroDias == "") {
          form = false
          SnackBarModule("Campo(s) obrigatório(s) não informado(s)s.", "error");
        }

        if (element.numeroDias > this.saldoFerias) {
          form = false
          SnackBarModule("Saldo insuficiente", "error");
        }

        if (element.numeroDias == 0) {
          form = false
          SnackBarModule("O número de dias deve ser maior que zero", "error");
        }

        if (index != this.campos - 1) {
          if (this.form[this.campos - 1].dataInicio <= element.dataFim) {
            form = false;
            SnackBarModule("A data início deverá ser maior que a data final da última parcela", "error");
          }
        }

        formData.append(`feriasEscolares[${index}][exercicio]`, this.form[index].exercicio)
        formData.append(`feriasEscolares[${index}][data_ini]`, this.form[index].dataInicio)
        formData.append(`feriasEscolares[${index}][data_fin]`, this.form[index].dataFim)
        formData.append(`feriasEscolares[${index}][dias]`, this.form[index].numeroDias)
        formData.append(`feriasEscolares[${index}][id_sigrh]`, this.selected[0].idSigrh)

        if (element.idStatus == 1) {
          formData.append(`idsFerias[${index}]`, element.idFerias)
          formData.append(`feriasEscolares[${index}][id_ferias]`, element.idFerias)
        }
      });

      if (form) {
        this.sendForm(formData);
        return;
      }
    },
    async getExercicioItems() {
      this.loading.field = true;
      const response = await FeriasEscolaresService.getExercicios(this.selected[0].idSigrh);
      this.exerciciosOptions = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.exerciciosOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },
    async calculateDays(index) {

      if (this.form[index].dataInicio) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form[index].dataInicio).format("YYYY-MM-DD"));
        formData.append("dias", this.form[index].numeroDias);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form[index].dataFim = response.dataFim;
        this.form[index].numeroDias = response.dias_uteis;
        this.form[this.campos] = {}
        this.form.pop()

        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },
    calcularTotalDiasRestantes() {
      const diasRestantesPorExercicio = {};

      for (const value of this.form) {
        const exercicio = value.exercicio;
        const numeroDias = parseInt(value.numeroDias) || 0;

        if (!exercicio) continue;

        if (!diasRestantesPorExercicio[exercicio]) {
          diasRestantesPorExercicio[exercicio] = this.saldoFerias > 0 ? this.saldoFerias : 25;
        }

        if (numeroDias > diasRestantesPorExercicio[exercicio]) {
          SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 25 por exercício", "error");
          return;
        }

        diasRestantesPorExercicio[exercicio] -= numeroDias;
      }

      this.form.forEach((item, index) => {
        if (item.exercicio) {
          this.$set(this.form, index, {
            ...this.form[index],
            subtitulo: `Você possui um saldo de ${diasRestantesPorExercicio[item.exercicio] ?? 0} dia(s) no exercício ${item.exercicio}`,
          });
        }
      });

      if (this.form.length === 1) {
        this.$forceUpdate();
      }
    },
    async sendForm(formData) {
      this.loading.btn = true;
      const response = await FeriasEscolaresService.agendarFeriasEscolares(formData);
      this.loading.btn = false;
      if (response) {
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },
    close() {
      this.initializeForm();
      this.$emit("on-close");
    },
    async createNewForm() {
      this.campos = this.campos + 1;

      this.form[this.campos - 1] = {
        subtitulo: "Calculando saldo...",
        exercicio: null,
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        justificativa: null,
        idFerias: null,
        idStatus: null,
      };

      if (this.form[this.campos - 1].exercicio) {
        await this.atualizarSaldoFerias(this.campos - 1);
      }
    },
    async atualizarSaldoFerias(index) {
      if (!this.form[index].exercicio) return;

      const formData = new FormData();
      formData.append("exercicio", this.form[index].exercicio);
      formData.append("id_tipo", 3);
      formData.append("id_ferias", this.form[index].idFerias);

      try {
        const response = await SolicitarFeriasService.pegarDiasRestantes(formData);

        this.saldoFerias = response.dias;
        this.$set(this.form, index, {
          ...this.form[index],
          subtitulo: `Você possui um saldo de ${response.dias} dia(s) no exercício ${response.exercicio}`,
        });

        if (this.form.length === 1) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }

      } catch (error) {
        console.error("Erro ao buscar saldo de férias:", error);
        this.$set(this.form, index, { ...this.form[index], subtitulo: "Erro ao calcular saldo." });
      }
    },
    removePeriodoFerias() {
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos - 1].numeroDias)
      this.form.pop()
      this.campos = this.campos - 1
    },
  },
};